import clsx from "clsx"

import styles from "./PriorityIcon.module.scss"

// Glyph color by level: orange for urgent, muted for no priority, strong text otherwise.
export function getPriorityIconClassName(priority: JobPriority): string {
    return clsx(styles.base, { [styles.urgent]: priority === 1, [styles.none]: priority === null })
}
